import "./styles/UserMangement.css";
import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import PersonIcon from "@mui/icons-material/Person";
import SearchIcon from "@mui/icons-material/Search";
import { useTable } from "react-table";
import { BasicTable } from "../components/scripts/Table2";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import "../components/styles/QueueContent.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { Box } from '@mui/material';
import "../components/styles/Tabs.css";
import PopOutModal from "../components/scripts/PopOutModal";
import RemoveIcon from "@mui/icons-material/Remove";
import Api_Call from "../ApiCall";
import info from "../info.json";
import SkillManagementTable from "../components/scripts/SkillManagementTable";
const wt = 200;
const ht = 50;
const colms = [
  {
    width: 150,
    height: ht,
    Header: "User ID",
    accessor: "USER_ID",
  },
  {
    width: wt,
    height: ht,
    Header: "User Name",
    accessor: "USER_NAME",
  },
  {
    width: wt,
    height: ht,
    Header: "Email ID",
    accessor: "EMAIL_ID",
  },
  {
    width: 220,
    height: ht,
    Header: "Employee ID",
    accessor: "EMP_ID",
  },
  {
    width: 220,
    height: ht,
    Header: "Supervisor",
    accessor: "SUPERVISOR",
  },
  {
    width: wt,
    height: ht,
    Header: "Supervisor ID",
    accessor: "SUPERVISOR_ID",
  },
  {
    width: wt,
    height: ht,
    Header: "Team",
    accessor: "TEAM",
  },
  {
    width: wt,
    height: ht,
    Header: "Role",
    accessor: "ROLE",
  },
  {
    width: 250,
    height: ht,
    Header: "Date of Joining",
    accessor: "DATE_OF_JOINING",
  },
  {
    width: 100,
    height: ht,
    Header: "Active",
    accessor: "ACTIVE",
  },
  {
    // width: 100,
    height: ht,
    Header: "Action",
    accessor: "",
  },
];

const columns = [
  {
    Header: "Skill",
    accessor: "Title",
  },
];

const SkillMapping = () => {
  const [loading, setLoading] = useState(false);
  const [dataForTable, setDataForTable] = useState([]);
  const [dataForTableSkill, setDataForTableSkill] = useState([]);
  const [isSkillMapping, setisSkillMapping] = useState(true);
  const [isEditPressedForSkillMapping, setIsEditPressedForSkillMapping] =
    useState(false);
  const [searchHeader, setSearchHeader] = useState("");
  const [skillsArrayForUser, setSkillsArrayForUser] = useState([]);

  console.log(skillsArrayForUser);

  const headerRows =
    searchHeader == ""
      ? []
      : dataForTableSkill.filter((item) => {
          return item.Header.toLowerCase().includes(searchHeader.toLowerCase());
        });
  useEffect(async () => {
    setLoading(true);

    try {
      const api = new Api_Call();
      const data = await api.getData(`UI/USER_MANAGEMENT`, info.BASE_URL_ADMIN);
      setDataForTable(data.body);
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(async () => {
    setLoading(true);
    try {
      const api = new Api_Call();
      const data = await api.getData(
        `UI/SKILL-ENROLLMENT`,
        info.BASE_URL_ADMIN
      );
      const obj = data.body[0];
      const dataToTable = Object.keys(obj)
        .map((item) =>
          obj[item]["Skills"].map((item2) => {
            return {
              ...item2,
              Header: item,
              Header_ID: obj[item]["Header_ID"],
            };
          })
        )
        .flat();

      setDataForTableSkill(dataToTable);
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleSubmit = async () => {
    setIsEditPressedForSkillMapping(false);
    try {
      const arrayToSend = skillsArrayForUser
        .map((item) => item.Skill_ID)
        .filter((item) => item != null || item != "" || item != undefined);
      const api = new Api_Call();
      const data = await api.postData(
        `UI/SKILL-MAPPING`,
        {
          user_id: sessionStorage.getItem("userIdInUserManagement"),
          skill_id: arrayToSend,
          user_role_id: sessionStorage.getItem("userRoleId"),
        },
        info.BASE_URL_ADMIN
      );

      toast.success(data.body);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <Box className="primary-title-new">
        <img src="img/heading-bg.png" />
        <Typography variant="h1">Skill Mapping</Typography>
      </Box>

      <div>
        <div className="content-main">
          <div className="user-content-container">
            <div className="tasklist-table specific-table">
              <Box>
                <BasicTable
                  basic="true"
                  columns={colms}
                  isSkillMapping={isSkillMapping}
                  isEditPressedForSkillMapping={isEditPressedForSkillMapping}
                  setIsEditPressedForSkillMapping={
                    setIsEditPressedForSkillMapping
                  }
                  //   editHandler={editHandler}
                  tableData={dataForTable}
                  //   tableDataSkill={dataForTableSkill}
                  //   setDataForEdit={setDataForEdit}
                  //   setisEditPressed={setisEditPressed}
                  loading={loading}
                  skillsArrayForUser={skillsArrayForUser}
                  setSkillsArrayForUser={setSkillsArrayForUser}
                  //   addHandler={() => {
                  //     displayPopup();
                  //   }}
                ></BasicTable>
              </Box>
            </div>
          </div>
        </div>
      </div>
      <PopOutModal
        isOpen={isEditPressedForSkillMapping}
        onClose={() => setIsEditPressedForSkillMapping(false)}
        content={
          <div>
            <div className="rebuttal--heading">
              Add Skills
              <button
                className="rebuttal--main-container__right--buttons-submit"
                onClick={() => {
                  handleSubmit();
                }}
              >
                Submit
              </button>
            </div>
            <SkillManagementTable
              columns={columns}
              tableData={
                searchHeader == ""
                  ? dataForTableSkill.sort((a, b) => a.Header_ID - b.Header_ID)
                  : headerRows
              }
              searchHeader={searchHeader}
              isSkillMapping={isSkillMapping}
              setSearchHeader={setSearchHeader}
              skillsArrayForUser={skillsArrayForUser}
              setSkillsArrayForUser={setSkillsArrayForUser}
            ></SkillManagementTable>
          </div>
        }
      ></PopOutModal>
    </>
  );
};

export default SkillMapping;
